import LeaderboardBracket from "./LeaderboardBracket";

export default LeaderboardBracket;
